<template>
<div id="partner-app" v-if="id">
  <h2>Partner App #{{ partnerAppId }}</h2>

  <partner-app-nav
    :partnerId="partnerId"
    :partnerAppId="partnerAppId"
  ></partner-app-nav>

  <table class="table">
    <tr>
      <td>
        Name
      </td>
      <td>
        {{ name }}
      </td>
    </tr>
    <tr>
      <td>
        Authentication Token
      </td>
      <td>
        {{ authentication_token }}
      </td>
    </tr>
    <tr>
      <td>
        Slug
      </td>
      <td>
        {{ slug }}
      </td>
    </tr>
    <tr>
      <td>
        Description
      </td>
      <td>
        {{ description }}
      </td>
    </tr>
    <tr>
      <td>
        Inactive?
      </td>
      <td>
        {{ inactive }}
      </td>
    </tr>
    <tr>
      <td>
        Created At
      </td>
      <td>
        {{ this.$root.displayDateTimeFmt(created_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Updated At
      </td>
      <td>
        {{ this.$root.displayDateTimeFmt(updated_at) }}
      </td>
    </tr>
  </table>
</div>
</template>

<script>
import PartnerAppNav from '@/components/PartnerAppNav'

import PartnerAppStore from '@/stores/PartnerAppStore'

export default {
  data () {
    return PartnerAppStore.state
  },

  components: {
    'partner-app-nav': PartnerAppNav
  },

  props: ['partnerId', 'partnerAppId'],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet(
        '/partners/' + this.partnerId + '/partner_apps/' + this.partnerAppId,
        PartnerAppStore, true
      )
    },

    deleteApp (ev) {
      if (confirm('Are you sure you want to delete this app? This action cannot be undone.')) {
        const ele = ev.target

        this.$http.delete(this.apiUrl(ele.getAttribute('href'), true)).then((resp) => {
          this.processSuccess(resp, PartnerAppStore)
        }, this.processErrors)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerApp.vue